export default __webpack_public_path__ + "static/media/personality.bb0ac762.svg";